import { load } from "@cashfreepayments/cashfree-js";
import { api } from "../../utils/apiHandler";
import { useTranslation } from "react-i18next";
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { config } from "../../utils/config";

const currencySymbols = {
  usd: "$",
  inr: "₹",
  eur: "€",
  gbp: "£",
};

const BankPurchase = ({
  packages,
  grantPackages,
  setShowBankPopup,
  getUserData,
}) => {
  const { t } = useTranslation();
  const cashfreeRef = useRef(null);
  const navigate = useNavigate();
  const rawHandle = localStorage.getItem("handle");
  const handle = rawHandle ? JSON.parse(rawHandle) : null;
  const isLoggedIn = handle?.user?.phone_number != null;
  const gateway = "stripe"; // or "cashfree"

  const doPayment = (id) => {
    if (gateway === "stripe") {
      const selectedPackage = packages.find((pkg) => pkg.id === id);
      navigate("/stripe/checkout", {
        state: { selectedPackage },
      });
      return;
    }

    api.post("/orders", { package_id: id }).then((res) => {
      let checkoutOptions = {
        paymentSessionId: res.data.order.payment_session_id,
        redirectTarget: "_modal",
      };
      cashfreeRef?.current.checkout(checkoutOptions).then((result) => {
        if (result.error) {
          // This will be true whenever user clicks on close icon inside the modal or any error happens during the payment
          toast.error(t("paymentFailToast"), {
            position: "bottom-center",
            autoClose: 2000,
            className: "custom-toastify",
            icon: false,
          });
        }
        if (result.paymentDetails) {
          // This will be called whenever the payment is completed irrespective of transaction status
          const payload = {
            payment_session_id: res.data.order.payment_session_id,
            order_id: res.data.order.order_id,
          };
          api.patch(`/orders/${res.data.order.id}/verify`, payload).then(() => {
            getUserData();
            setShowBankPopup(false);
          });
        }
      });
    });
  };

  useEffect(() => {
    const initializeSDK = async () => {
      cashfreeRef.current = await load({
        mode: config.isDevelopment ? "sandbox" : "production",
      });
    };
    initializeSDK();
  }, []);

  const signUpPackage = grantPackages?.find(
    (pkg) => pkg.name === "Sign up bonus",
  );

  const renderCard = (item) => {
    const formattedAmount = (item.amount_cents / 100).toFixed(2);
    const cardContent = (
      <div
        key={item.id}
        onClick={() => doPayment(item.id)}
        className={` ${
          item.name !== "Most Popular" &&
          item.name !== "Best Deal" &&
          " w-[calc(50%-4px)]"
        } border-[2px] cursor-pointer border-sangati-green bg-white p-2 bank-shadow`}
      >
        <div className="text-sangati-orange font-sharetech text-[40px] text-center">
          {item.credits}
        </div>
        <button className="bg-sangati-green p-1 font-sharetech w-full text-white mx-auto rounded-[5px] text-20">
          {currencySymbols[item.currency]} {formattedAmount}
        </button>
      </div>
    );

    if (item.name === "Most Popular") {
      return (
        <div
          key={item.id}
          className="bg-sangati-orange w-[calc(50%-4px)] -mt-4 border border-sangati-orange bank-shadow rounded-[5px] flex flex-col"
        >
          <span className="text-center text-12 text-white">
            {t("mostPopular")}
          </span>
          {cardContent}
        </div>
      );
    } else if (item.name === "Best Deal") {
      return (
        <div
          key={item.id}
          className="bg-[#262F68] -mt-4 w-[calc(50%-4px)] border border-sangati-orange bank-shadow rounded-[5px] flex flex-col "
        >
          <span className="text-center text-12 text-white">
            {t("bestDeal")}%
          </span>
          {cardContent}
        </div>
      );
    } else {
      return cardContent;
    }
  };

  return (
    <>
      {isLoggedIn ? (
        <div className="flex flex-wrap justify-center  gap-2 gap-y-6 items-center w-full p-2">
          {packages.map(renderCard)}
        </div>
      ) : (
        <div className="flex flex-col  h-full w-full justify-center items-center">
          <div
            onClick={() => navigate(`/login?redirect=/sangati`)}
            className="bg-sangati-orange  -mt-4 border border-sangati-orange bank-shadow rounded-[5px] flex flex-col"
          >
            <span className="text-center text-12 text-white">{t("free")}</span>

            <div
              className={`  border-[2px] cursor-pointer border-sangati-green bg-white p-2 bank-shadow rounded-[5px]`}
            >
              <div className="text-sangati-orange font-sharetech text-[40px] text-center">
                {signUpPackage?.credits}
              </div>
              <button className="bg-sangati-green p-1 px-2 font-sharetech w-full text-white mx-auto rounded-[5px] text-20">
                {t("logIn")}
              </button>
            </div>
          </div>

          <p className="text-12 mt-2 text-center">
            {t("availDeals")}
          </p>
        </div>
      )}
    </>
  );
};

export default BankPurchase;
